import CityPageTemplate from "../city-template/CityPageTemplate";
import { gardenGroveConfig } from "./data";

export default function GardenGrovePage() {
  return <CityPageTemplate config={gardenGroveConfig} />;
}